'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const {QueryRenderer} = require('react-relay');
import getRelayEnvironment from '../../relayClientEnvironment';
const abExperiments = require('../../utils/abExperiments');
const { getUserId, cookieJarConstants } = require('dibs-cookie-jar');
const checkoutStorage = require('../checkoutStorage');



let optimizelyVariant = 'control';
if (abExperiments.makeOfferCheckbox) {
    Promise.resolve(abExperiments.makeOfferCheckbox)
        .then(res => { optimizelyVariant = res; });
}

function MakeOfferRenderer(props) {
    const { modalProps } = props;
    const {
        MakeOfferModal,
        LowBall,
        MakeOffer,
        AbandonMakeOfferModal,
        ModalWrapper,
        Confirmation,
        queries
    } = modalProps.contactComponents;
    const { makeOffer } = queries;
    const { itemId, sellerId } = modalProps;
    const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER) || '';
    const params = {
        userId,
        userIds: [userId],
        itemId,
        itemIds: [itemId],
        sellerId,
        shouldFetchUser: !!userId,
        shouldFetchTransaction: !!userId,
        isMC: false
    };

    return (
        <QueryRenderer
            environment={ getRelayEnvironment() }
            query={ makeOffer }
            variables={ params }
            render={({error, props: rendererProps}) => {// eslint-disable-line react/display-name, react/prop-types
                if (error) {
                    return (
                        <ModalWrapper
                            openOnRender
                            isError
                        />
                    );
                } else if (rendererProps) {
                    return (
                        <MakeOfferModal
                            viewer={rendererProps.viewer}
                            item={rendererProps.viewer.item}
                            conversation={null}
                            {...modalProps}
                            optimizelyVariant={optimizelyVariant}
                        >
                            <MakeOffer />
                            <LowBall />
                            <AbandonMakeOfferModal
                                onAbandonMakeOfferSuccess={() => {
                                    checkoutStorage.clearPreAuthOfferModalInfo();
                                    checkoutStorage.unsetSurveyInfo();
                                    checkoutStorage.unsetAutoModalInfo();
                                }}
                                onLeaveAbandonMakeOffer={checkoutStorage.clearPreAuthOfferModalInfo}
                            />
                            <Confirmation />
                        </MakeOfferModal>
                    );
                } else {
                    return (
                        <ModalWrapper
                            openOnRender
                            isLoading
                        />
                    );
                }
            }}
        />
    );
};

MakeOfferRenderer.propTypes = {
    queryProps: PropTypes.object,
    modalProps: PropTypes.object
};

export default MakeOfferRenderer;




// WEBPACK FOOTER //
// ./src/abandonedCheckout/components/MakeOfferRenderer.jsx